<script setup lang="ts">
import { LanguageMenu, type LanguageMenuItem } from '@sunlabde/m2m-library';
import { computed } from 'vue';
import { useBreakpoints } from '@vueuse/core';
import { useLanguage } from '@/composables/useLanguage';
import { globalBreakpoints } from '@/utilities/Breakpoints';

const {
	composeLinkWithNewLocale,
	availableLanguages,
	selectedLanguage,
} = useLanguage();

const mappedSelectedLanguage = computed(() => ({
	label: selectedLanguage.value.name,
	link: composeLinkWithNewLocale(selectedLanguage.value.code),
	languageCode: selectedLanguage.value.code,
}));

const languageMenuItems = computed((): LanguageMenuItem[] => Object.values(availableLanguages.value).map((locale) => ({
	label: locale.nativeName,
	link: composeLinkWithNewLocale(locale.code),
	languageCode: locale.code,
})));

const { smallerOrEqual } = useBreakpoints(globalBreakpoints);
const isSmallerOrEqualDesktop = smallerOrEqual('desktop');
</script>

<template>
	<LanguageMenu
		:available-languages="languageMenuItems"
		:model-value="mappedSelectedLanguage"
		:is-tooltip-hidden="isSmallerOrEqualDesktop"
	/>
</template>
